import { render, staticRenderFns } from "./CustomerAddressList.vue?vue&type=template&id=19d4974c&scoped=true"
import script from "./CustomerAddressList.vue?vue&type=script&lang=js"
export * from "./CustomerAddressList.vue?vue&type=script&lang=js"
import style0 from "./CustomerAddressList.vue?vue&type=style&index=0&id=19d4974c&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19d4974c",
  null
  
)

export default component.exports